<template>
  <el-card class="h-full relative flex flex-col">
    <div class="h-full flex flex-col">
      <div class="flex-auto h-0px">
        <el-table ref="table" :data="tableData" border class="w-full" :height="tableHeight" stripe v-loading="loading">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="考试名称" prop="ExamName" show-overflow-tooltip></el-table-column>
          <el-table-column label="考试编号" prop="ExamCode" show-overflow-tooltip></el-table-column>
          <el-table-column label="考试开始时间" prop="ExamStartTime" show-overflow-tooltip min-width="160">
            <template slot-scope="scope">
              {{ scope.row.ExamStartTime | dateFilter }}
            </template>
          </el-table-column>
          <el-table-column label="考试结束时间" prop="ExamEndTime" show-overflow-tooltip min-width="160">
            <template slot-scope="scope">
              {{ scope.row.ExamEndTime | dateFilter }}
            </template>
          </el-table-column>
          <el-table-column label="考试时长(分钟)" prop="ExamDuration" show-overflow-tooltip></el-table-column>
          <el-table-column label="考试发起人" prop="Name" show-overflow-tooltip></el-table-column>
          <el-table-column label="考生人数" prop="ExamineeCount" show-overflow-tooltip></el-table-column>
          <el-table-column label="考试状态" prop="ExamState" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ stateList.find(item => item.value === scope.row.ExamState).label || '' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否补考" prop="IsPass" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.IsPass === 1 ? '否' : scope.row.IsPass === null ? '' : '是' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="160">
            <template slot-scope="scope">
              <el-button size="mini" @click.native="handleEvent(scope.row, 'startExam')" v-if="scope.row.ExamState === 2" :disabled="!($hasAccess('startExam')&&
                scope.row.ExamState === 2)
                ">{{ scope.row.IsPass === null || scope.row.IsPass ? '开始考试' : '补考' }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @size-change="searchList" @current-change="findList" :current-page.sync="pageNo"
          :page-size.sync="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]" :total="total" class="float-right mt-20px ml-10px"></el-pagination>
      </div>
    </div>
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import DiyService from '@/modules/educational-training-management-sm/services/DiyService'


export default {
  name: 'question-task',
  filters: {
    dateFilter(value) {
      return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
    },
  },
  data() {
    return {
      nowTime: dayjs(),
      FormData: {},
      formDialog: false,
      id: '',
      formProps: {
        title: '新增考试任务',
        visible: false,
        // create 新增 update 编辑 read 详情
        editType: 'create',
      },
      // 作业活动清单
      tableData: [],
      loading: false,
      searchData: {},
      total: 0,
      pageNo: 1,
      pageSize: 15,
      selectionData: [],
      timer: null,
      stateList: [
        { value: 1, label: '未开始' },
        { value: 2, label: '进行中' },
        { value: 3, label: '已结束' },
      ],
      isQuestion: false,
      questionId: '',
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  activated() {
    if (this.timer) return
    this.timer = setInterval(() => {
      this.nowTime = dayjs()
    }, 1000)
  },
  deactivated() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  created() {
    this.searchList()
    if (this.timer) return
    this.timer = setInterval(() => {
      this.nowTime = dayjs()
    }, 5000)
  },
  methods: {
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    async findList() {
      const data = {
        ApiEngineKey: 'get_exam_task_list',
        PageSize: this.pageSize,
        PageIndex: this.pageNo,
      }
      this.loading = true
      const [err, res] = await DiyService.getInterfaceList(data)
      if (!err && res.Code === 1) {
        this.tableData = res.Data
        this.total = res.DataCount
      } else {
        this.$message.error(res.Msg)
      }
      this.loading = false
    },
    // 列表操作-事件
    async handleEvent(row = {}, operation) {
      switch (operation) {
        case 'startExam':
          if (this.nowTime > dayjs(row.ExamEndTime)) {
            this.$message.warning(`考试时间已过，无法${row.IsPass === null || row.IsPass ? '开始考试' : '补考'}`)
            return
          }
          if (this.nowTime < dayjs(row.ExamStartTime)) {
            this.$message.warning(`考试未开始，无法${row.IsPass === null || row.IsPass ? '开始考试' : '补考'}`)
            return
          }
          const params = {
            ApiEngineKey: 'start_exam',
            TaskId: row.Id,
          }
          const [err, res] = await DiyService.getInterfaceList(params)
          if (!err && res.Code === 1) {
            this.$router.push({
              path: 'online-question',
              query: {
                id: res.Data.Id,
              },
            })
          } else {
            this.$message.error(res.Msg)
          }
          break
        default:
          break
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
